module.exports = __webpack_public_path__ + "static/img/blue_limi_1.3f06529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/pk/blue_limi_1.png
// module id = CxfT
// module chunks = 1